import React from 'react';
import { Link } from 'react-router-dom';

function Analytics() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* SEO META HEADERS */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Global Medical Tourism Statistics 2026: Independent Patient Traffic Analytics Index
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '20px' }}>
          Welcome to the digital software transparency repository hosted by <strong>Medical Trip World</strong>. As an unaligned informational directory and research venue, we monitor international lookup queries, medical search trends, and volume shares to help border-crossing patients map cost-saving private care routes across India's premier corporate healthcare destinations.
        </p>
      </header>

      {/* CORE DATA STRIP */}
      <section style={{ marginTop: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #ff9f1c', paddingBottom: '6px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Cross-Border Private Care Traffic Distribution Matrices
        </h2>
        <p style={{ color: '#555', fontSize: '0.95rem', lineHeight: '1.6' }}>
          By processing independent web logs from global travel corridors, our operational software maps out high-intent data metrics for private corporate hospital selections:
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '20px' }}>
          <div style={{ padding: '20px', background: '#f4f8fb', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.2rem' }}>Middle East Healthcare Corridors</h3>
            <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#444' }}><strong>Volume Share:</strong> 42% of total search traffic indexes.</p>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>Primary keywords revolve around advanced coronary artery bypass graft (CABG), robotic valve repairs, and complex oncology tumor protocols in private medical hubs.</p>
          </div>

          <div style={{ padding: '20px', background: '#f4f8fb', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#005ba1', fontSize: '1.2rem' }}>East & Central African Corridors</h3>
            <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#444' }}><strong>Volume Share:</strong> 31% of total search traffic indexes.</p>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>Driven heavily by long-tail queries regarding robotic total knee replacements, revision hip arthroplasty, and targeted bone marrow transplant options.</p>
          </div>

          <div style={{ padding: '20px', background: '#f4f8fb', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#28a745', fontSize: '1.2rem' }}>South & Central Asian Corridors</h3>
            <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#444' }}><strong>Volume Share:</strong> 27% of total search traffic indexes.</p>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>Dominating fields include full-arch cosmetic dental implants, electronic medical visa document tracking timelines, and private corporate hospital sitemap listings.</p>
          </div>
        </div>
      </section>

      {/* SEO BLOCK OUT */}
      <section style={{ marginTop: '35px', background: '#fafafa', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '4px', border: '1px solid #eee' }}>
        <h3 style={{ color: '#333', marginTop: '0', fontSize: '1.2rem' }}>Database Logging Transparency & Compliance Notice</h3>
        <p style={{ margin: '0', fontSize: '0.9rem', color: '#555', lineHeight: '1.6' }}>
          All mathematical variables displayed on this independent dashboard are synthesized from open web search entries and public keyword density matrices. Medical Trip World functions entirely as an informational directory and template manual. We do not manage clinical triage registries, handle patient admission charts, hold biological health files, or execute legal medical partnerships/MOUs with private clinic networks. All surgical care, financial transactions, and specific diagnostic parameters remain exclusively between the traveling family and their self-selected medical professional.
        </p>
      </section>

    </article>
  );
}

export default Analytics;